import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { blogPosts } from '../mockData';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-indigo-50 to-blue-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-blue-600 font-semibold text-lg mb-4 tracking-wide uppercase">Our Blog</h3>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Expert Insights, Industry Trends & <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">Innovation</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Discover the newest advancements in technology, software development, and digital transformation. 
            Gain a competitive edge with expert analysis, emerging trends, and practical tips from our specialists.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <Card 
              key={post.id}
              onClick={() => navigate(`/blog/${post.slug}`)}
              className="group overflow-hidden border-2 border-gray-100 hover:border-blue-300 transition-all duration-500 hover:shadow-2xl transform hover:-translate-y-2 cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative overflow-hidden h-64">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 via-blue-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors duration-300 leading-tight">
                  {post.title}
                </h3>
                <Button 
                  variant="link" 
                  className="text-blue-600 hover:text-blue-700 p-0 font-semibold group/btn"
                >
                  Read More 
                  <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform duration-300" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button 
            onClick={() => navigate('/blog')}
            size="lg"
            className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-8 py-6 text-lg rounded-full shadow-xl hover:shadow-2xl transition-all duration-300"
          >
            View All Blog Posts
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Blog;